import { render, staticRenderFns } from "./SwipedSelectedSpotLight.vue?vue&type=template&id=195ef974&scoped=true&"
import script from "./SwipedSelectedSpotLight.vue?vue&type=script&lang=js&"
export * from "./SwipedSelectedSpotLight.vue?vue&type=script&lang=js&"
import style0 from "./SwipedSelectedSpotLight.vue?vue&type=style&index=0&id=195ef974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195ef974",
  null
  
)

export default component.exports